import { render, staticRenderFns } from "./veSbzcJzwInspecttypeEdit.vue?vue&type=template&id=69fab874&scoped=true"
import script from "./veSbzcJzwInspecttypeEdit.vue?vue&type=script&lang=js"
export * from "./veSbzcJzwInspecttypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fab874",
  null
  
)

export default component.exports